"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocaleProvider = exports.LocaleContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const LOCALES = {
  de: true,
  en: false
};

const validateLocale = locale => {
  locale = typeof locale !== "string" ? (0, _utils.extractLanguage)(ALL_LOCALES) : locale;
  return locale in LOCALES ? locale : DEFAULT_LOCALE;
};

const ALL_LOCALES = Object.keys(LOCALES);

const DEFAULT_LOCALE = (() => ALL_LOCALES.find(key => !!LOCALES[key]))();

const LocaleProvider = _ref => {
  let {
    locale: initialLocale,
    ...props
  } = _ref;
  const [locale, setLocale] = (0, _react.useState)(validateLocale(initialLocale));
  const setLocaleValidated = (0, _react.useCallback)(locale => {
    setLocale(validateLocale(locale));
  }, []);
  const value = (0, _react.useMemo)(() => ({
    locale,
    locales: ALL_LOCALES,
    setLocale: setLocaleValidated,
    defaultLocale: DEFAULT_LOCALE
  }), [locale, setLocaleValidated]);
  return /*#__PURE__*/_react.default.createElement(LocaleContext.Provider, _extends({
    value: value
  }, props));
};

exports.LocaleProvider = LocaleProvider;
LocaleProvider.propTypes = {
  initialLocale: _propTypes.default.oneOf(ALL_LOCALES)
};
const LocaleContext = /*#__PURE__*/(0, _react.createContext)();
exports.LocaleContext = LocaleContext;